import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

export type ServerDiagnosticFields = Record<string, string | undefined>;

export function serializeDiagnostics(fields: ServerDiagnosticFields): string {
  const present = Object.keys(fields)
    .sort()
    .reduce<Record<string, string>>((carry, key) => {
      const value = fields[key]?.trim();
      if (value) carry[key] = value;
      return carry;
    }, {});

  return Object.keys(present).length ? JSON.stringify(present) : '';
}

export function useServerDiagnostics(surface: string, fields: ServerDiagnosticFields): void {
  const diagnostics = serializeDiagnostics(fields);

  useEffect(() => {
    if (!diagnostics) return;
    Sentry.logger.warn(
      Sentry.logger.fmt`[OfflineMode] Server-authored text withheld from ${surface}`,
      { surface, diagnostics }
    );
  }, [diagnostics, surface]);
}
